export const getRedirecturl = () =>{
  if(typeof window !== "undefined"){
    return `${window.location.origin}`;
  }
}


const oidcConfig = {
  authority: process.env.REACT_APP_AUTHORITY || "",
  client_id: process.env.REACT_APP_CLIENTID || "",  
  redirect_uri: getRedirecturl() as string + "/callback", 
  logout_redirect_uri: process.env.REACT_APP_LOGOUT_URL || "", 
  response_type: 'code', 
  scope: 'openid profile email',
  automaticSilentRenew: true, 
  filterProtocolClaims: true, 
  loadUserInfo: true, 
  fscMediaKitLink: "https://onefscb2c.b2clogin.com/onefscb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=b2c_1a_fscbrandhub_openidsignin&client_id=110daace-0b38-48e6-aa9a-bccc8d44b9c3&scope=110daace-0b38-48e6-aa9a-bccc8d44b9c3%20openid%20email&response_type=code&redirect_uri=https%3A%2F%2Foak.fsc.org%2Fauth%2Flogin%2Fazure%2Fcallback&access_type=offline&code_challenge=ysnPJoa2RXsoENO6vUDsdXDh0ocGv7sq3s5T6r-MDvc&code_challenge_method=S256&state=ysnPJoa2RXsoENO6vUDsdXDh0ocGv7sq3s5T6r-MDvc&nonce=ysnPJoa2RXsoENO6vUDsdXDh0ocGv7sq3s5T6r-MDvc"
};

export default oidcConfig;